import { PropertyStatus } from "./types";
import type { PropertyStatusFilter } from "./types";

export const PROPERTIES_LIST_QUERY_KEY = ["admin", "properties", "list"] as const;
export const PROPERTY_DETAIL_QUERY_KEY = ["admin", "properties", "detail"] as const;

export const DEFAULT_PAGE_SIZE = 25;
export const SEARCH_DEBOUNCE_MS = 300;

/**
 * Capacity-pivot edit bounds — mirror the API DTO validators:
 * `UpdatePropertyInput.maxGuests` is `@Min(1) @Max(50)`, and
 * `AdminUpdatePropertyInput.dailyPassCap` is `@Min(1) @Max(MAX_DAILY_PASS_CAP)`
 * where `MAX_DAILY_PASS_CAP = 100` (`read-daily-pass-cap.ts`). Kept in sync
 * here so the BO fails fast before the round-trip; the API stays authoritative.
 */
export const MIN_MAX_GUESTS = 1;
export const MAX_MAX_GUESTS = 50;
export const MIN_DAILY_PASS_CAP = 1;
export const MAX_DAILY_PASS_CAP = 100;
/** Geofence radius in MILES — `AdminUpdatePropertyInput.geofenceRadius` is `@Min(1)@Max(20)` (Float). */
export const MIN_GEOFENCE_RADIUS = 1;
export const MAX_GEOFENCE_RADIUS = 20;

/**
 * Status options for the filter dropdown. `all` first (default), then
 * the lifecycle order an operator scans. Mirrors the API's
 * `PropertyStatus` enum.
 */
export const PROPERTY_STATUS_FILTERS: readonly PropertyStatusFilter[] = [
  "all",
  PropertyStatus.ACTIVE,
  PropertyStatus.TRIAL,
  PropertyStatus.PAUSED_NO_VENUES,
  PropertyStatus.INACTIVE,
  PropertyStatus.SUSPENDED,
];
